/**
 * 车险管理-报价记录
 */

export default {
    name: 'AutoInsuranceQuoteList',
    path: '/AutoInsuranceQuoteList',
    component: () => import('@/views/vehicleInsuranceQuoteList/'),
    redirect: { name: 'AutoInsuranceQuoteListIndex' },
    meta: {
        title: '报价记录',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: 'AutoInsuranceQuoteListIndex',
            path: 'index',
            component: () => import('@/views/vehicleInsuranceQuoteList/home/Home.vue'),
        },
        {
            name: 'AutoInsuranceQuoteListDetail',
            path: 'read',
            component: () => import('@/views/vehicleInsuranceQuoteList/detail/Detail.vue'),
        },
    ],
};
